/**
 * Rôle lu dans le JWT, sans vérification de signature : pour l'affichage
 * seulement (quels boutons montrer). L'API décide toujours.
 */
export function jwtRole(jwt: string | null): string | null {
  try {
    const payload = JSON.parse(atob(jwt!.split('.')[1]!.replace(/-/g, '+').replace(/_/g, '/'))) as { role?: string };
    return payload.role ?? null;
  } catch {
    return null;
  }
}

/** Le JWT a-t-il expiré (champ `exp`) ? Jeton illisible ou sans `exp` : non. */
export function jwtExpired(jwt: string | null, now = Date.now()): boolean {
  try {
    const payload = JSON.parse(atob(jwt!.split('.')[1]!.replace(/-/g, '+').replace(/_/g, '/'))) as { exp?: number };
    return typeof payload.exp === 'number' && payload.exp * 1000 <= now;
  } catch {
    return false;
  }
}

/** Rôles qui gardent la pose libre de leur bureau (hors emplacement). */
export const FREE_DESK_PLACEMENT_ROLES = ['OWNER', 'ADMIN'];
